import { Autocomplete, Box, Modal, Slide, Button, Typography } from "@mui/material"
import { CstmTextField } from "../../../../../../core/global/forms/CstmTextField"
import { Generate } from "./Generate"
import { useContext } from "react"
import { ToolContext } from "../../../../../../core/context/ToolContext"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import moment from "moment"
import { DataSetArray } from "./DataSetArray"
import Excel from "../../../../../../assets/images/icons/excel.png"
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export const Thead = ({inputChangeHandler, branchData, branchProductData, snackBarLoader, open, setOpen}) => {
    const {tool_state, report_state} =useContext(ToolContext)
    const {__SESSION} = tool_state
    const {comProductIds, generateForm, salesProductData, salesProductList, form} = report_state

    return (
        <>
            <Box sx={{width: "100%", display: "flex", gap: 2, mb: 2}}>
                <Button onClick={()=>{setOpen(true)}} fullWidth variant="contained" sx={{width: salesProductList.data.length > 0 ? "50%": "100%", borderRadius: 2, fontSize: 14, boxShadow: 0, py: 1, minHeight: "48px"}}>
                    Generate
                </Button>
                {salesProductList.data.length > 0 && (
                    <Box sx={{width: "100%"}}>
                        <ExcelFile filename={`Sales_Product_Reports_${moment(new Date()).format('MM/DD/YYYY')}`}
                            element={
                                <Box display="flex" alignItems="center" className="c-pointer" border={2} bgcolor="#d5ffe6ff" borderColor="#ffffffff" borderRadius={2} padding="12px 16px" width="100%"  justifyContent="center">
                                    <img src={Excel} alt="excel-img" />
                                    <Box ml="10px" color="#1D6F42" fontSize={14}>Export in excel</Box>
                                </Box>
                            }
                        >
                            <ExcelSheet dataSet={DataSetArray(salesProductList.data)} name="Reports" />
                        </ExcelFile>
                    </Box>
                )}
            </Box>
        
            <Modal open={open} onClose={()=>{setOpen(false)}}>
                <Slide in={open} direction="up">
                    <Box minHeight="170px" display="flex" flexDirection="column" gap={1.5} position="absolute" bottom={0} width="100%">
                        <Box width="100%" display="flex" flexDirection="column"  alignItems="center" gap={3} bgcolor="#FFFFFF" sx={{borderTopLeftRadius: 8, borderTopRightRadius: 8}} px={2} pt={4} pb={2}>
                            <Box sx={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                                <Typography>Generate Branch Product Sales</Typography>
                                <CloseRoundedIcon onClick={()=>{setOpen(false)}}/>
                            </Box>
                            <Box width="100%" id="walkthrough-branch-product-report-step-1">
                                <Autocomplete   
                                    fullWidth
                                    options={branchData.data}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, value) => inputChangeHandler(e, value, 'branch_id')}
                                    value={ form.data.branch_id === '' ? null : branchData.data.find((f) => f.company_branch_id === form.data.branch_id) || null} 
                                    renderInput={(params) => (
                                        <CstmTextField {...params} label="Branch" placeholder="Branch" />
                                    )}
                                />
                            </Box>
                            <Box width="100%" id="walkthrough-branch-product-report-step-2">
                                <Autocomplete
                                    fullWidth
                                    options={branchProductData || []} 
                                    getOptionLabel={(option) => {
                                        if (!option) return ''; 
                                        const alias = option.alias || '';
                                        const subCat = option.sub_cat_name || '';
                                        const product = option.product_name || '';
                                        return alias.trim() === '' ? `${subCat} ${product}` : alias;
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id} 
                                    onChange={(e, value) => inputChangeHandler(e, value, 'product_id')}
                                    value={
                                        form.data.product_id === ''
                                            ? null
                                            : branchProductData.find((f) => f.id === form.data.product_id) || null
                                    }
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option.alias?.trim() === '' || option.alias === null
                                                ? `${option.sub_cat_name || ''} ${option.product_name || ''}`
                                                : option.alias}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <CstmTextField {...params} label="Product" placeholder="Product" />
                                    )}
                                />
                            </Box>
                            <CstmTextField id="walkthrough-branch-product-report-step-3" fullWidth type="date" variant="outlined" label="Date From" name="from" InputLabelProps={{shrink: true}} 
                            InputProps={{ inputProps: { max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.from} error={snackBarLoader.data && form.data.from === ''}/>
                            <CstmTextField  id ="walkthrough-branch-product-report-step-4" fullWidth type="date" variant="outlined" label="Date To" name="to" InputLabelProps={{shrink: true}} InputProps={{inputProps: {min: form.data.from, max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.to} error={((snackBarLoader.data && form.data.to === '') || (form.data.to < form.data.from))}/>
                            <Generate __SESSION={__SESSION} snackBarLoader={snackBarLoader} form={form.data} comProductIds={comProductIds} generateForm={generateForm.data} setGenerateForm={generateForm.set} salesProductData={salesProductData.data} setSalesProductData={salesProductData.set} salesProductList={salesProductList.data} setOpen={setOpen} />
                        </Box>
                    </Box>
                </Slide>
            </Modal>
        </>
    )
}